import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Champs communs (campagne et modèle) : objet, texte, bouton, page de destination.
export const ContentFields = ({ value, onChange, prefix = "content" }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="space-y-3">
      <div>
        <Label className="text-xs">Visuel en haut de l'e-mail</Label>
        <select value={value.theme || "default"} onChange={set("theme")} className="h-10 w-full rounded-md border border-white/15 bg-black/40 px-3 text-sm text-white" data-testid={`${prefix}-theme`}>
          <option value="default">Logo BougieDuCœur</option>
          <option value="toussaint">Toussaint : logo Toussaint + bougie du site</option>
        </select>
      </div>
      <div>
        <Label className="text-xs">Objet de l'e-mail (commencez par un emoji, ex. 🙏)</Label>
        <Input value={value.subject || ""} onChange={set("subject")} data-testid={`${prefix}-subject`} />
      </div>
      <div>
        <Label className="text-xs">Texte (HTML simple accepté · variables {"{{prenom}}"} et {"{{nom}}"})</Label>
        <textarea value={value.body_html || ""} onChange={set("body_html")} rows={8} className="w-full resize-y rounded-md border border-white/15 bg-black/40 p-2 font-mono text-xs text-white outline-none focus:border-fuchsia-400/60" data-testid={`${prefix}-body`} />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <Label className="text-xs">Texte du bouton</Label>
          <Input value={value.button_label || ""} onChange={set("button_label")} data-testid={`${prefix}-button`} />
        </div>
        <div>
          <Label className="text-xs">Page ouverte au clic (ex. /toussaint-2026)</Label>
          <Input value={value.target_url || ""} onChange={set("target_url")} placeholder="/" data-testid={`${prefix}-target`} />
        </div>
      </div>
    </div>
  );
};
